<template>
  <div class="result-tag">
    <a href="#" @click.prevent="getResults">
      <span class="hash">#</span>
      <i class="mdi mdi-close"></i>
    </a>
    <span>{{ item.option.label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {
    selected() {
      return this.$store.state.sort.selected;
    },
  },

  methods: {
    getResults() {
      this.$store.dispatch("removeSearchParam", this.item);

      let obj = {
        term: (this.searchTerm = this.$store.state.sort.term),
        metaStyles: this.flattenQuery(this.selected.metaStyles),
        styles: this.falttenStylesQuery(this.selected.styles),
        levels: this.flattenQuery(this.selected.levels),
        durations: this.flattenQuery(this.selected.durations),
        tempo: this.flattenQuery(this.selected.tempo),
        teachers: this.flattenQuery(this.selected.teachers),
        focus: this.flattenQuery(this.selected.focus),
        bodyPart: this.flattenQuery(this.selected.bodyPart),
        equipment: this.flattenQuery(this.selected.equipment),
      };

      this.$store.dispatch(`getVideoResults`, obj);
    },
    flattenQuery(arr) {
      const ids = arr.map(item => item.id);
      return ids.join(",");
    },
    falttenStylesQuery(arr) {
      const ids = arr.map(item => item.resource.id);
      return ids.join(",");
    },
  },
};
</script>

<style lang="scss">
.result-tag {
  position: relative;
  border-radius: 20px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25);
  padding: 0.5rem 1.2rem;
  background-color: #ffffff;
  margin-left: 1rem;
  margin-bottom: 1rem;
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.35);
    .hash {
      display: none;
    }
    .mdi {
      display: inline;
    }
  }

  a {
    color: #000000;
  }
  .mdi {
    display: none;
  }
  .hash {
    font-size: 1.1rem;
    display: inline-block;
    width: 16px;
  }
}
</style>
  
